<template>
  <div class="content-box" style="position: relative;">
    <div class="content-box-title">
      <van-image
        :src="require('../assets/img/title-icon.png')"
        width="18px"
        height="18px"
        class="icon"
      ></van-image>
      <span>护照地图</span>
    </div>
    <div class="content-box-container" style="position: relative;">
      <div style="padding:5px 0" v-if="isMap">
        <div class="passport-map">
          <!-- <div class="passport-map-finish" v-if="showFinish">
            徽章数：<span>{{ finishNum }}</span>
          </div> -->
          <div class="passport-map-info"></div>
          <div
            v-for="(map, i) in ppnMapList"
            :key="i"
            :class="['passport-map-img', 'map' + (i + 1)]"
            :style="{
              backgroundImage:
                'url(' + (map.studyCourseNum / map.courseNum == 1 ? map.url1 : map.url2) + ')',
            }"
            @click="getCourse(i + 1)"
          >
            <!-- <span>{{ map.studyCourseNum }}/{{ map.courseNum }}</span> -->
            <span>{{ map.mapName }}</span>
          </div>
        </div>
        <div style="position: absolute;bottom:5px;right:5px;" class="rmk-txt">
          不含充电保
        </div>
      </div>
      <div class="map-list" v-else>
        <div class="map-list-btn">
          <!-- <div @click="backList" v-show="!isMap">查看全部</div> -->
          <div
            :class="{ active: currentMap == map.id }"
            @click="selectMap(map.id)"
            v-for="(map, i) in mapList"
            :key="i"
          >
            {{ map.title }}
          </div>
        </div>
        <div class="map-list-info">
          <div>
            <!--            徽章获取进度：<span>{{ badges }} / {{ badgeTotal }}</span>-->
            已学课程/全部课程
          </div>
          <div>
            学分：<span class="int">{{ int }}</span>
          </div>
        </div>
        <div class="map-list-detail">
          <div
            class="map-badge"
            :style="{
              backgroundImage:
                'url(' +
                ppnMapList[currentMap - 1][
                  ppnMapList[currentMap - 1].studyCourseNum /
                    ppnMapList[currentMap - 1].courseNum ==
                  1
                    ? 'url1'
                    : 'url2'
                ] +
                ')',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
            }"
          >
            <div class="map-badge-info">
              <div
                class="process"
                :style="{
                  left: currentMap == 5 ? '-15px' : null,
                  top: currentMap == 5 ? '-5px' : null,
                }"
              >
                <div
                  class="bar"
                  :style="{
                    width:
                      (ppnMapList[currentMap - 1].studyCourseNum /
                        ppnMapList[currentMap - 1].courseNum) *
                        100 +
                      'px',
                  }"
                ></div>
              </div>
              <div>
                {{ ppnMapList[currentMap - 1].studyCourseNum }}/{{
                  ppnMapList[currentMap - 1].courseNum
                }}
              </div>
            </div>

            <!-- <div
              class="map-badge-info"
              v-for="(e, i) in courseList"
              :key="i"
              :style="{
                top: e.coordinate[1] + 'px',
                left: e.coordinate[0] + 'px',
              }"
            >
              <van-icon name="flag-o" size="20" color="#D5001C" />
            </div> -->
          </div>
        </div>

        <div class="course passport">
          <div class="cource-list-tool">
            <div @click="changeType(2)" :class="{ active: currentType == 2 }">已学课程</div>
            <div @click="changeType(3)" :class="{ active: currentType == 3 }">未学课程</div>
          </div>
          <div class="cource-list">
            <div
              class="cource-list-item"
              v-for="(item, i) in courseList"
              :key="i"
              @click="showDetailPop(item)"
            >
              <div :class="{ name: true, lr: item.learningFlag == '0' }">
                <van-image
                  :src="
                    require('../assets/img/c-type-' + (item.source ? item.source : '1') + '.png')
                  "
                  width="24"
                  height="16"
                />
                {{ item.courseName }}
              </div>
              <div class="price" v-if="item.learningFlag == '1'">
                +{{ item.integral.toLocaleString('en-US') }}
              </div>
              <div>
                <span v-if="item.learningFlag == '1'" class="complete"
                  ><van-icon name="success" />Completed</span
                >
                <span v-else>Not Started</span>
              </div>
            </div>
          </div>
          <van-pagination
            v-show="courseList.length != 0"
            class="course-page"
            v-model="page"
            :total-items="total"
            :items-per-page="size"
            mode="simple"
            @change="changePage"
          />
        </div>
      </div>
    </div>
    <div class="back-btn" @click="backList" v-show="!isMap" style="bottom:30%">返回</div>
    <van-popup v-model="showDetail" round position="bottom" :style="{ minHeight: '40%' }">
      <div class="detail-pop">
        <div class="detail-pop-title">
          <div>课程详情</div>
          <van-image
            :src="require('../assets/img/close.png')"
            width="22"
            height="22"
            @click="showDetail = false"
          />
        </div>
        <div class="detail-pop-contnet">
          <h3>{{ detailItem.courseName }}</h3>
          <div
            v-html="detailItem.introduction ? detailItem.introduction : detailItem.courseName"
          ></div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getMyCourse, getMapList } from '@/api/common/index.js'
import { getUserByPpn } from '@/api/user/index.js'
export default {
  name: 'new',
  props: {
    ppn: {
      type: String,
    },
    showFinish: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    ppn() {
      this.getPPNMap()
    },
  },
  data() {
    return {
      currentMap: 1,
      isMap: true,
      badgeTotal: 0,
      badges: 0,
      int: 0,
      ppnMapList: [],
      mapList: [],
      courseList: [],
      finishNum: 0,
      page: 1,
      size: 10,
      total: 0,
      showDetail: false,
      detailItem: '',
      currentType: 2,
    }
  },
  methods: {
    showDetailPop(obj) {
      this.detailItem = obj
      this.showDetail = true
    },
    backList() {
      this.isMap = true
      this.$emit('handleMonth', true)
      this.$emit('handleShowBack', true)
    },
    selectMap(id) {
      this.$emit('handleMonth', false)
      this.currentMap = id
      this.page = 1
      this.setNum(id - 1)
      this.getCourse(id)
    },
    setNum(index) {
      this.badgeTotal = this.ppnMapList[index].courseNum
      this.badges = this.ppnMapList[index].studyCourseNum
      this.int = this.ppnMapList[index].studyIntegral
        ? this.ppnMapList[index].studyIntegral.toLocaleString('en-US')
        : 0
    },
    changePage(val) {
      this.page = val
      this.getCourse(this.currentMap)
    },
    changeType(type) {
      this.currentType = type
      this.page = 1
      this.getCourse(this.currentMap)
    },
    getCourse(mapId) {
      this.currentMap = mapId
      this.setNum(mapId - 1)
      this.isMap = false
      this.$emit('handleMonth', false)
      this.$emit('handleShowBack', false)
      let isLearn = this.currentType == 2 ? '1' : this.currentType == 3 ? '0' : ''
      getMyCourse(
        {
          learningFlag: isLearn,
          ppn: this.ppn,
          mapId: this.currentMap,
        },
        this.page,
        this.size
      ).then((res) => {
        this.courseList = res.rows
        this.total = res.total
      })
    },
    getMap() {
      getMapList({}).then((res) => {
        this.mapList = res.data
      })
    },
    getPPNMap() {
      getUserByPpn({
        ppn: this.ppn,
      }).then((res) => {
        this.finishNum = 0
        //if (res.data.userMapList.length != 0) {
        res.data.userMapList.forEach((item) => {
          if (item.mapStudy == '1') {
            this.finishNum++
          }
        })
        this.ppnMapList = res.data.userMapList
        //}
        // else {
        //   this.ppnMapList = this.mapList
        // }
      })
    },
  },
  created() {},
  mounted() {
    this.getMap()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.passport-map {
  position: relative;
  // margin-top: 15px;
  // margin-bottom: 10px;
  width: 266px;
  height: 157px;
  margin: 0px auto;
  // background: url('../assets/img/map.png') center no-repeat;
  // background-size: cover;
  .passport-map-finish {
    position: absolute;
    top: 0px;
    left: -20px;
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    & > span {
      color: #d5001c;
    }
  }
  .passport-map-info {
    position: absolute;
    top: 0px;
    right: -30px;
    color: #333333;
    font-size: 12px;
    font-weight: 400;
  }
  .passport-map-img {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    font-size: 12px;
    color: #fff;
    span {
      font-size: 10px;
    }
    &.map1 {
      left: 0px;
      bottom: 0px;
      width: 120px;
      height: 60px;
      span {
        position: relative;
        display: inline-block;
        top: -5px;
      }
    }
    &.map2 {
      left: 5px;
      top: 25px;
      width: 100px;
      height: 73px;
    }
    &.map3 {
      left: 90px;
      bottom: 10px;
      width: 96px;
      height: 65px;
      span {
        position: relative;
        display: inline-block;
        top: -5px;
        left: 8px;
      }
    }
    &.map4 {
      left: 100px;
      top: 10px;
      width: 65px;
      height: 79px;
      span {
        position: relative;
        display: inline-block;
        left: -4px;
      }
    }
    &.map5 {
      right: 5px;
      bottom: 10px;
      width: 73px;
      height: 73px;
      span {
        position: relative;
        display: inline-block;
        top: -5px;
        left: -5px;
      }
    }
    &.map6 {
      right: 0px;
      top: 28px;
      width: 110px;
      height: 57px;
      z-index: 99;
      span {
        position: relative;
        display: inline-block;
        top: -2px;
        left: -5px;
      }
    }
  }
}
.map-list {
  // margin-top: 10px;
  &-btn {
    // margin-bottom: 10px;
    padding: 5px 10px;
    & > div {
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 5px 5px 0;
      padding: 0 8px;
      height: 22px;
      border: 1px solid #b5b4ba;
      transform: skewX(-15deg);
      border-radius: 4px;
      color: #737278;
      font-size: 11px;
      &.active {
        background: linear-gradient(180deg, #7d7d7d 0%, #403f45 100%);
        color: #fff;
      }
    }
  }
  &-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #403f45;
    font-size: 14px;
    font-weight: 400;
    padding: 5px 10px;
    span {
      font-family: 'Porsche Next';
      &.int {
        color: #d5001c;
      }
    }
  }
  &-detail {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 206px;
    padding: 10px;
    .map-badge {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: 220px;
      height: 162px;
      margin: 0 auto;
      .map-badge-info {
        text-align: center;
        color: #fff;
        font-size: 14px;
        .process {
          position: relative;
          display: flex;
          align-items: center;
          width: 88px;
          height: 10px;
          background: url('../assets/img/process-bg.png') center no-repeat;
          background-size: contain;
          margin-bottom: 5px;
          .bar {
            height: 0;
            border-width: 6px 6px 0px 0px;
            border-style: solid solid none;
            border-color: #d5001c transparent transparent;
          }
        }
      }
    }
  }
}
.course.passport {
  margin: 10px;
  padding-bottom: 10px;
  .course-page {
    margin-top: 10px;
    .van-pagination__item {
      color: #d5001c;
    }
  }
}
</style>
